export function createScript(languageCode: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.id = 'cookie-consent-script';
    script.src = 'https://policy.app.cookieinformation.com/uc.js';
    script.type = 'text/javascript';
    script.async = true;
    script.dataset.culture = languageCode;
    return script;
}
